import {
  calculateColumnWidth,
  mapColumnTypes,
  selectColumnFactory,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema/schemaFields";

import schema from "./schema";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.phoneNumber, "Phone Number"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.country, "Country"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.carrier, "Carrier"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          schema.fields.authorizedFirstName,
          "Authorized First Name"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          schema.fields.authorizedLastName,
          "Authorized Last Name"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          schema.fields.billingTelephoneNumber,
          "Billing Phone Number"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.customerName, "Customer Name"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.address, "Address"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.accountNumber, "Account Number"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.pin, "Pin"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.notes, "Notes"),
        type: TYPES.STRING,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
